import React from 'react';

import Icons from '../utils/icons';

export default function NeoIcon({ config }) {
	if(!config.icon || !Icons[config.icon]) {
		return null;
	}

	const Icon = Icons[config.icon];

	return <Icon className="wz-neo-icon"/>
}
